//~ import { jsonToGraphQLQuery, EnumType } from "json-to-graphql-query";
import fetch from "node-fetch";
/*
ce module permet d'utiliser les mêmes queries dans les composants,
lorsque l'on veut fetch les produits
que ce soit au runtime (dans le browser) ou bien lors du build
*/
const queryBuilder = ({ filters, sorters, combinator, limit, output, after }, runtime = true) => {
    const { handPicked, // an array of ids
    category, //array of categories
    attribute, //should the name of the attributes along with their values
    onSales, //boolean
    price, //float range
    tags, //array of tags
    search, //string
     } = filters || {};
    output = {
        __on: [
            {
                __typeName: (runtime ? "" : "wp_gql_") + "VariableProduct",
                id: true,
                name: true,
                uri: true,
            },
            {
                __typeName: (runtime ? "" : "wp_gql_") + "ExternalProduct",
                id: true,
                name: true,
                uri: true,
            },
            {
                __typeName: (runtime ? "" : "wp_gql_") + "SimpleProduct",
                id: true,
                name: true,
                uri: true,
            },
            {
                __typeName: (runtime ? "" : "wp_gql_") + "GroupProduct",
                id: true,
                name: true,
                uri: true,
            },
        ],
        name: true,
        id: true,
        databaseId: true,
        slug: true,
        productCategories: {
            nodes: {
                databaseId: true,
                name: true,
                uri: true,
            },
        },
        productTags: {
            nodes: {
                databaseId: true,
                name: true,
                uri: true,
            },
        },
        attributes: {
            nodes: {
                variation: true,
                options: true,
                label: true,
                id: true,
                attributeId: true,
                __on: [
                    {
                        __typeName: (runtime ? "" : "wp_gql_") + "GlobalProductAttribute",
                        slug: true,
                        terms: {
                            nodes: {
                                databaseId: true,
                                slug: true,
                                name: true,
                            },
                        },
                    },
                ],
            },
        },
        ...(output || {}),
    };
    if (!combinator || combinator !== "AND") {
        combinator = "OR";
    }
    //~ if (!limit) {
    //~ limit = 3;
    //~ }
    if (!sorters || Object.keys(sorters).length === 0) {
        sorters = {
            field: "DATE",
            order: "DESC",
        };
    }
    if (Object.keys(sorters).length != 2) {
        return false;
    }
    const filter = {};
    const query = {
        query: {},
    };
    if (handPicked) {
        handPicked.slice(0, 3).forEach((id, i) => {
            const product = {
                __aliasFor: "product",
                __args: {
                    id: parseInt(id),
                    //~ idType: new EnumType("DATABASE_ID")
                },
                ...output,
            };
            query.query["Product" + i] = product;
        });
    }
    if (category) {
        filter.categoryIdIn = category;
    }
    if (tags) {
        filter.tagIdIn = tags;
    }
    if (typeof onSales !== "undefined") {
        filter.onSale = onSales;
    }
    if (price) {
        if (price.min) {
            filter.minPrice = price.min;
        }
        if (price.max) {
            filter.maxPrice = price.max;
        }
    }
    if (search && search.length) {
        filter.search = search;
    }
    const products = {
        __args: {
            where: {
                orderby: {
                //~ field: new EnumType(sorters.field),
                //~ order: new EnumType(sorters.order)
                },
                ...filter,
            },
        },
        edges: {
            cursor: true,
            node: {
                ...output,
            },
        },
    };
    if (limit) {
        products.__args.first = limit;
    }
    if (attribute && attribute.length) {
        attribute.forEach((attr, i) => {
            const key = "pa_" + attr.key;
            const term = attr.term;
            const attrProducts = {
                ...products,
                __args: {
                    ...products.__args,
                    where: {
                        ...products.__args.where,
                        attribute: key,
                        attributeTerm: term,
                    },
                },
                __aliasFor: "products",
            };
            if (after && after.length && after[i]?.length) {
                attrProducts.__args.after = after[i];
            }
            query.query["Products_" + attr.key + "_" + attr.term] = attrProducts;
        });
    }
    else {
        if (after && after.length && after[0]?.length) {
            products.__args.after = after;
        }
        query.query.products = products;
    }
    if (!runtime) {
        query.query = {
            wp_gql: {
                ...query.query,
            },
        };
    }
    //~ return jsonToGraphQLQuery(query, { pretty: true });
};
const queryFetcher = async (query, endpoint) => {
    const results = await fetch(endpoint, {
        method: "POST",
        body: JSON.stringify({ query, variables: null }),
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
    return await results.json();
};
const queryHandler = async (query, after) => {
    //~ if (typeof after !== "undefined" && (after === false || after.every(e => e === false))) {
    //~ return { results: [], next: false };
    //~ }
    //~ if (after && after.length) {
    //~ query.after = after;
    //~ }
    //~ const graphQ = queryBuilder(query);
    //~ results = await queryFetcher(graphQ, "http://auto-wp.docker.localhost/wp/index.php?graphql=");
    //~ return resultsFlattener(results);
};
const resultsFlattener = (results) => {
    console.log(results);
    let values = Object.values(results.data || results.wp_gql || results);
    let after = values.map((e) => {
        if (!e || !e.edges || !e.edges.length) {
            return false;
        }
        return e.edges[e.edges.length - 1].cursor;
    });
    after = after.every((e) => e === false) ? false : after;
    try {
        values = values
            .flatMap((e) => e.edges.map((edge) => ({ cursor: edge.cursor, ...edge.node })))
            .filter((e, i, a) => a.findIndex((f) => f.id === e.id) === i);
    }
    catch { }
    console.log(values.filter((e) => e !== null));
    return { results: values.filter((e) => e !== null), next: after };
};
export { queryBuilder, queryFetcher, queryHandler, resultsFlattener };
